/* ==========================================================================
   product.js — PAGE PRODUIT (For.me)
   --------------------------------------------------------------------------
   1) --fm-pdp-offset   : haut de la section -> hauteur plein écran (CSS)
   2) --fm-pdp-hero-img : image active -> reflet (CSS, si utilisé)
   3) GALERIE custom : filtre par variante (via l'ALT = nom de variante),
      slides EMPILÉS (une seule visible), transition = BALAYAGE (.fm-enter),
      navigation par les miniatures gérée ici.
   Ne s'exécute QUE sur les pages produit.
   ========================================================================== */
(function () {
  'use strict';

  var main = document.getElementById('MainContent');
  var tpl = main && main.getAttribute('data-template') || '';
  if (tpl.indexOf('product') !== 0) return;

  var WIPE_MS = 460;   /* durée du balayage (garde ~= à la valeur CSS fm-wipe + petite marge) */
  var changing = false;   // true pendant un changement de variante

  /* ======================================================================
     EMPÊCHE LE THÈME DE REMPLACER NOTRE GALERIE au changement de variante.
     Le thème fait un fetch /products/...?option_values=... puis remplace tout
     le <media-gallery> (~370ms plus tard) -> lenteur + petit saut. Comme NOUS
     gérons déjà l'affichage (les 33 images sont là), on retire le
     <media-gallery> de SA réponse : il ne trouve plus rien à remplacer, garde
     notre galerie, mais met quand même à jour le prix / le bouton / la dispo.
     Mets PREVENT_THEME_GALLERY_SWAP = false pour revenir au comportement d'avant.
     ====================================================================== */
  var PREVENT_THEME_GALLERY_SWAP = false;
  if (PREVENT_THEME_GALLERY_SWAP && window.fetch) {
    var _origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isVariant = /\/products\//.test(url) && /[?&](option_values=|variant=|section_id=)/.test(url);
      var p = _origFetch.apply(this, arguments);
      if (!isVariant) return p;
      return p.then(function (resp) {
        try {
          var ct = (resp.headers.get('content-type') || '');
          if (ct.indexOf('html') < 0) return resp;
        } catch (e) { return resp; }
        return resp.clone().text().then(function (html) {
          // on neutralise UNIQUEMENT le media-gallery (le reste est intact)
          var stripped = html.replace(/<media-gallery[\s\S]*?<\/media-gallery>/gi, '<template data-fm-removed-gallery></template>');
          return new Response(stripped, { status: resp.status, statusText: resp.statusText, headers: resp.headers });
        }).catch(function () { return resp; });
      });
    };
  }

  /* Écart entre les étoiles et le nombre d'avis. NÉGATIF = plus proche des
     étoiles (ex : '-4px'), positif = plus loin. (Réglé en JS car l'app d'avis
     force un margin:0 inline qu'un CSS ne peut pas battre.) */
  var COUNT_GAP = '4px';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  /* IMPORTANT : on se limite à la galerie de la fiche produit.
     Sans ce cadrage, querySelectorAll('#MainContent slideshow-slide') ramasse
     AUSSI les slides des cartes de la section "recommandations" en bas de page
     -> la barre comptait des dizaines d'images fantômes. */
  var GAL = '#MainContent .product-information__media ';
  function slidesArr() {
    var a = [].slice.call(document.querySelectorAll(GAL + 'slideshow-slide'));
    // repli si la structure change : on ne casse pas la galerie
    if (!a.length) a = [].slice.call(document.querySelectorAll('#MainContent media-gallery slideshow-slide'));
    return a;
  }
  function thumbsArr() { return [].slice.call(document.querySelectorAll(GAL + '.slideshow-controls__thumbnail')); }
  function dotsArr()   { return [].slice.call(document.querySelectorAll(GAL + '.slideshow-controls__dots > li')); }
  function activeSlide() {
    var a = slidesArr();
    for (var i = 0; i < a.length; i++) if (a[i].classList.contains('fm-active')) return a[i];
    return null;
  }
  function slideAlt(slide) {
    var img = slide && slide.querySelector('.product-media__image');
    return norm(img && img.getAttribute('alt'));
  }
  function firstVisibleSlide() {
    var s = slidesArr();
    for (var i = 0; i < s.length; i++) if (s[i].style.display !== 'none') return s[i];
    return null;
  }

  function heroSection() {
    var info = document.querySelector('#MainContent .product-information');
    return info ? info.closest('.shopify-section') : null;
  }

  /* ---- image "figée" (évite l'écran vide pendant le re-render du thème) --- */
  function mediaEl() { return document.querySelector('#MainContent .product-information__media'); }
  function removeFreeze() {
    var f = document.querySelector('#MainContent .product-information__media .fm-freeze');
    if (f && f.parentNode) f.parentNode.removeChild(f);
  }
  function showFreeze() {
    var media = mediaEl();
    var cur = activeSlide() || firstVisibleSlide();
    var img = cur && cur.querySelector('.product-media__image');
    if (!media || !img) return;
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src) return;
    var r = img.getBoundingClientRect();
    var mr = media.getBoundingClientRect();
    if (!r.width || !r.height) return;
    removeFreeze();
    var box = document.createElement('div');
    box.className = 'fm-freeze';
    // recouvre EXACTEMENT l'image active (position + taille au pixel) -> aucun étirement
    box.style.cssText =
      'position:absolute;z-index:1;pointer-events:none;overflow:hidden;border-radius:30px;' +
      'left:' + Math.round(r.left - mr.left) + 'px;' +
      'top:' + Math.round(r.top - mr.top) + 'px;' +
      'width:' + Math.round(r.width) + 'px;' +
      'height:' + Math.round(r.height) + 'px;' +
      'background-image:url("' + src.replace(/"/g, '') + '");' +
      'background-size:cover;background-position:center;';
    media.appendChild(box);
  }

  /* ---- badge de réduction -X% (repris de la product card) --------------- */
  function priceNum(el) {
    if (!el) return NaN;
    var t = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
    return parseFloat(t);
  }
  function injectBadge(container) {
    if (!container) return;
    var old = container.querySelector('.price-discount-badge');
    var sale = container.querySelector('.price-item__group.price, .price');
    var comp = container.querySelector('.compare-at-price');
    var s = priceNum(sale), c = priceNum(comp);
    if (!comp || !isFinite(s) || !isFinite(c) || !(c > s)) {   // pas en promo -> pas de badge
      if (old && old.parentNode) old.parentNode.removeChild(old);
      return;
    }
    var label = '-' + Math.round((1 - s / c) * 100) + '%';
    if (old) {
      if (old.textContent !== label) old.textContent = label;   // évite une mutation inutile (pas de boucle)
      return;
    }
    var badge = document.createElement('span');
    badge.className = 'price-discount-badge';
    badge.textContent = label;
    container.appendChild(badge);
  }
  function updateDiscountBadge() {
    // 1) bloc prix de la fiche
    injectBadge(document.querySelector('#MainContent .product-information product-price [ref="priceContainer"]')
             || document.querySelector('#MainContent .product-information product-price'));
    // 2) barre sticky add-to-cart
    injectBadge(document.querySelector('.sticky-add-to-cart__price [ref="priceContainer"]')
             || document.querySelector('.sticky-add-to-cart__price'));
  }

  /* ---- nombre d'avis : ne garder que le chiffre + forcer l'affichage/couleur --
     L'app d'avis (Inflate) impose des styles INLINE !important (display:none,
     color:#212121...) et les REPOSE ~1s après le chargement. Un CSS externe ne
     peut pas les battre, et il faut REPOSER notre style à chaque fois que l'app
     re-cache -> on surveille l'attribut style de l'élément. --- */
  function applyCountStyle(el) {
    var m = (el.textContent || '').match(/\d[\d.,\s]*/);   // 1er nombre trouvé
    if (m) {
      var num = m[0].replace(/[.,\s]+$/, '').trim();        // sans parenthèses/mot/espaces
      if (num && el.textContent.trim() !== num) el.textContent = num;
    }
    el.style.setProperty('display', 'inline-block', 'important');   // bat le display:none inline de l'app
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('color', '#212121', 'important');          // même couleur que les étoiles
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('margin-left', COUNT_GAP, 'important');   // écart réglable (voir COUNT_GAP en haut)
    el.style.setProperty('vertical-align', 'middle', 'important');
    /* taille/poids laissés à la valeur de base de l'app (pas de forçage) */
  }
  // (re)style tous les compteurs qui en ont besoin (garde-fou anti-boucle :
  // si display vaut déjà 'inline-block', on n'ré-applique pas le style)
  function styleAllCounts() {
    var els = document.querySelectorAll('#MainContent .product-information .rating-count');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.style.getPropertyValue('display') !== 'inline-block') {
        applyCountStyle(el);
      } else {
        var m = (el.textContent || '').match(/\d[\d.,\s]*/);   // garde le texte à jour
        if (m) { var num = m[0].replace(/[.,\s]+$/, '').trim(); if (num && el.textContent.trim() !== num) el.textContent = num; }
      }
    }
  }
  var _countObsSet = false, _countPollTicks = 0, _countPoll = null;
  function formatRatingCount() {
    styleAllCounts();
    // observateur unique sur la colonne qui contient les étoiles : rattrape le
    // re-masquage de l'app (changement de style) ET un éventuel remplacement de
    // l'élément (childList). En 3 colonnes, les avis sont dans .product-information__aside.
    if (!_countObsSet) {
      var pinfo = document.querySelector('#MainContent .product-information__aside')
               || document.querySelector('#MainContent .product-details');
      if (pinfo) {
        _countObsSet = true;
        new MutationObserver(function () { styleAllCounts(); })
          .observe(pinfo, { attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true });
      }
    }
    // filet : l'app re-cache ~1s après -> on repose le style toutes les 300ms
    // pendant 6s (large), puis on s'arrête (l'observateur prend le relais).
    if (!_countPoll) {
      _countPollTicks = 0;
      _countPoll = window.setInterval(function () {
        styleAllCounts();
        if (++_countPollTicks >= 20) { window.clearInterval(_countPoll); _countPoll = null; }
      }, 300);
    }
  }

  /* ---- COMPOSITION : n'afficher que les lignes de la variante ----------
     Chaque <p> commence par <strong>NOM VARIANTE CREAM/POWDER:</strong>.
     On ne garde que les lignes dont le nom == variante sélectionnée. --- */
  // clé de comparaison : minuscules, on enlève |, :, tirets, etc. et on compacte
  function keyify(s) {
    return (s || '').toLowerCase()
      .replace(/[|/\\·,;:_\-–—]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function compBase(strong) {
    // "HONEY HOUR CREAM:" -> "honey hour"  |  "01 NUDE:" -> "01 nude"
    var t = keyify(strong.textContent);
    t = t.replace(/\s*(cream|powder|poudre|creme|crème)\s*$/, '');
    return t.trim();
  }

  /* À QUELLE VARIANTE SE RAPPORTE CETTE LIGNE DE COMPOSITION ?
     Le rapprochement est délégué à fm-alt-match.js (window.FMAlt), le même
     helper qui rattache les images de la galerie à leur variante. L'intitulé
     n'a donc plus besoin d'être identique au nom de la variante : il suffit
     qu'il porte le ou les mots qui la distinguent des autres.

     Avec les variantes « 01 | Nude » et « 04 | Rosewood » :
       « 01 | Nude : »   -> 01 | Nude   (identique)
       « 01 NUDE : »     -> 01 | Nude   (casse et barre ignorées)
       « 01 NUDe : »     -> 01 | Nude
       « Nude : »        -> 01 | Nude   (le mot suffit à trancher)
       « 01 : »          -> 01 | Nude   (le numéro suffit)
       « 01 Nude cream : » -> 01 | Nude (le mot en trop est ignoré)
       « Rosewood : »    -> 04 | Rosewood
       « Toutes teintes : » -> aucune -> ligne affichée sur TOUTES les variantes
     Les accents sont retirés des deux côtés : « Nude Rosé » et « Nude Rose »
     sont la même chose.

     Rend '' quand l'intitulé ne désigne aucune variante en particulier, ou
     qu'il en désigne plusieurs autant l'une que l'autre. Dans ces deux cas la
     ligne est traitée comme commune et reste affichée partout — même parti
     pris que pour les images : mieux vaut une ligne vue partout qu'une ligne
     rattachée à la mauvaise teinte, donc invisible là où elle devrait être.
     En cas d'ambiguïté, FMAlt écrit un avertissement dans la console avec le
     nom des variantes en cause.

     Repli sur l'égalité stricte d'avant si fm-alt-match.js n'est pas chargé. */
  function compVariante(strong, noms) {
    var brut = strong.textContent.replace(/\s*:\s*$/, '');   // on retire les deux-points
    if (window.FMAlt) return window.FMAlt.match(brut, noms);
    var t = compBase(strong);
    for (var i = 0; i < noms.length; i++) if (keyify(noms[i]) === t) return noms[i];
    return '';
  }
  /* OÙ CHERCHER LES LIGNES DE COMPOSITION
     Trois emplacements, parce que la compo a déménagé et qu'elle peut
     maintenant apparaître à deux endroits sur la même page :
       1. l'accordéon de la colonne d'infos — l'emplacement d'origine ;
       2. les panneaux de la section « Onglets » (sections/fm-onglets.liquid),
          dans l'onglet « Ingrédients » ;
       3. le dépliant « Liste d'ingrédients complète » de la section
          « Ingrédients stars » (sections/fm-ingredients.liquid).
     Tous sont listés pour que le filtrage marche quel que soit l'endroit où
     la compo est posée, et dans tous à la fois si elle est posée plusieurs
     fois. Chacun est traité séparément (voir plus bas), donc en ajouter un
     ne peut pas dérégler les autres. */
  var COMPO_CONTENEURS =
    '#MainContent .product-information .accordion .details-content,' +
    '#MainContent .fmtabs__panel .fmtabs__content,' +
    '#MainContent .fming__compo';

  function filterComposition() {
    var sel = selectedVariant();           // ex. "01 | nude"
    if (!sel) return;
    var noms = variantNamesArr();
    if (!noms.length) return;

    /* UN CONTENEUR À LA FOIS, et non tous les paragraphes en vrac.
       C'est indispensable depuis le passage aux onglets : la FAQ est un
       panneau voisin, et elle aussi commence certaines lignes par
       <strong>…:</strong>. Si on mettait tout dans le même panier, la présence
       d'une vraie ligne de compo dans l'onglet « Ingrédients » ferait
       disparaître les lignes de la FAQ, qui ne portent évidemment pas de nom
       de variante. En traitant chaque panneau séparément, un panneau sans
       aucune correspondance est laissé intact. */
    [].forEach.call(document.querySelectorAll(COMPO_CONTENEURS), function (boite) {
      var comp = [].filter.call(boite.querySelectorAll('p'), function (p) {
        var s = p.querySelector('strong');
        return s && /:\s*$/.test(s.textContent);   // une ligne de composition = <strong>…:</strong>
      });
      if (!comp.length) return;

      /* La variante visée par chaque ligne, calculée une seule fois. */
      var vise = comp.map(function (p) { return compVariante(p.querySelector('strong'), noms); });

      /* Y a-t-il au moins une ligne pour la variante sélectionnée ? */
      var trouve = false;
      for (var i = 0; i < vise.length; i++) if (vise[i] === sel) { trouve = true; break; }

      /* Non : soit ce panneau n'est pas la composition (la FAQ, par exemple),
         soit cette variante n'a pas encore sa ligne. Dans les deux cas on
         n'efface rien, et on remet à zéro un éventuel masquage précédent —
         mieux vaut tout afficher qu'un onglet vide. */
      if (!trouve) {
        comp.forEach(function (p) { p.style.display = ''; });
        return;
      }

      /* Oui : on garde la ligne de la variante, et les lignes communes
         (vise === '') qui ne désignent aucune variante en particulier. */
      comp.forEach(function (p, k) {
        p.style.display = (vise[k] === sel || vise[k] === '') ? '' : 'none';
      });
    });
  }

  /* ---- accordéon : un seul ouvert à la fois -------------------------- */
  function setupExclusiveAccordion() {
    var accs = document.querySelectorAll('#MainContent .product-information .accordion');
    for (var i = 0; i < accs.length; i++) {
      var acc = accs[i];
      if (acc.__fmExclusive) continue;
      acc.__fmExclusive = true;
      // 'toggle' ne bulle pas -> écoute en phase de CAPTURE sur le conteneur
      acc.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d || d.tagName !== 'DETAILS' || !d.open) return;
        var others = this.querySelectorAll('details');
        for (var j = 0; j < others.length; j++) {
          if (others[j] !== d && others[j].open) others[j].open = false;   // ferme les autres
        }
      }, true);
    }
  }

  /* ---- 1) hauteur plein écran ----------------------------------------
     L'écart en-tête -> 1re section est réglé dans le CSS (header.css §11,
     --fm-product-offset) et la galerie le suit via
     --fm-top-bars: var(--fm-product-offset). Ici on ne fait que remonter la
     position de la section dans --fm-pdp-offset (au cas où). */
  function sizeHero() {
    var section = heroSection();
    if (!section) return;
    var offset = Math.round(section.getBoundingClientRect().top + window.scrollY);
    if (offset > 0) section.style.setProperty('--fm-pdp-offset', offset + 'px');
  }

  /* ---- 2) reflet (image active) -------------------------------------- */
  function setHeroImg() {
    var slide = activeSlide() || firstVisibleSlide();
    var img = slide && slide.querySelector('.product-media__image');
    var details = document.querySelector('#MainContent .product-details');
    if (!img || !details) return;
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src) details.style.setProperty('--fm-pdp-hero-img', 'url("' + src + '")');
  }

  /* ---- variantes ----------------------------------------------------- */
  /* LISTE des noms de variantes, dans l'ordre et sans doublon.
     C'est une liste et non un dictionnaire parce que le rapprochement
     alt <-> variante a besoin de voir TOUTES les variantes d'un coup : c'est
     en les comparant entre elles qu'il sait quels mots distinguent l'une de
     l'autre (voir fm-alt-match.js). */
  function variantNamesArr() {
    var vu = {}, out = [];
    document.querySelectorAll('#MainContent .product-details variant-picker input[type="radio"], #MainContent .product-information variant-picker input[type="radio"]').forEach(function (inp) {
      var v = norm(inp.value);
      if (v && !vu[v]) { vu[v] = 1; out.push(v); }
    });
    return out;
  }
  function selectedVariant() {
    var inp = document.querySelector('#MainContent variant-picker input[type="radio"]:checked')
           || document.querySelector('#MainContent variant-picker input[data-current-checked="true"]');
    return inp ? norm(inp.value) : '';
  }

  /* Variante à laquelle cette image se rapporte, ou '' si elle est commune à
     toutes. Le rapprochement est délégué à fm-alt-match.js : le texte
     alternatif n'a plus besoin d'être IDENTIQUE au nom de la variante, il
     suffit qu'il porte le ou les mots qui la distinguent — « Nude » suffit
     pour « 01 | Nude ».
     Repli sur l'ancienne règle (égalité stricte) si le script n'est pas
     chargé, pour que la galerie ne se mette jamais à tout afficher.
     `noms` est passé par l'appelant quand il boucle sur les images, pour ne
     pas relire le sélecteur de variantes à chaque tour. */
  function varianteDeLaSlide(slide, noms) {
    var alt = slideAlt(slide);
    if (!alt) return '';
    noms = noms || variantNamesArr();
    if (window.FMAlt) return window.FMAlt.match(alt, noms);
    return noms.indexOf(alt) !== -1 ? alt : '';
  }

  // 1re image SPÉCIFIQUE à la variante affichée, sinon null
  function featuredSlideForVariant() {
    var sel = selectedVariant();
    var slides = slidesArr();
    var noms = variantNamesArr();
    for (var i = 0; i < slides.length; i++) {
      if (varianteDeLaSlide(slides[i], noms) === sel) return slides[i];
    }
    return null;
  }

  /* ---- BARRE DE DÉFILEMENT (remplace les vignettes) --------------------
     Fine barre blanche posée EN BAS DE L'IMAGE (elle la surplombe) : un
     segment par image visible, le segment plein glisse en temps réel vers
     l'image affichée. La barre est mesurée sur l'image active, donc elle
     reste collée à l'image quelle que soit sa taille.
     Réglages : PROG_W = largeur de la barre (part de la largeur d'image)
                PROG_INSET = distance entre la barre et le BAS de l'image
     (épaisseur / couleurs : product.css §13) --- */
  var PROG_W = 0.40;
  var PROG_INSET = 22;
  /* COULEUR : mesurée sur les pixels réellement situés SOUS la barre.
     Fond clair -> barre #212121 ; fond foncé -> barre blanche.
     PROG_LUM_MAX = seuil de bascule (0 = noir, 1 = blanc) : monte-le pour que
     la barre reste blanche plus longtemps. */
  var PROG_LUM_MAX = 0.58;
  var _lumCache = {};
  /* Luminance moyenne du rectangle (fx, fy, fw, fh en fractions 0..1 de
     l'image) — c'est exactement l'emplacement de la barre. Les images venant
     du domaine du site, le canvas n'est pas bloqué ; en cas d'échec on
     renvoie null et la barre garde sa couleur précédente. */
  function luminanceAt(img, fx, fy, fw, fh) {
    try {
      var src = img.currentSrc || img.getAttribute('src') || '';
      if (!src || !img.complete || !img.naturalWidth) return null;
      var key = src + '|' + [fx, fy, fw, fh].map(function (v) { return Math.round(v * 100); }).join(',');
      if (key in _lumCache) return _lumCache[key];
      var W = 64, H = 80;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, W, H);
      var x0 = Math.max(0, Math.min(W - 1, Math.round(fx * W)));
      var y0 = Math.max(0, Math.min(H - 1, Math.round(fy * H)));
      var w = Math.max(1, Math.min(W - x0, Math.round(fw * W)));
      var h = Math.max(2, Math.min(H - y0, Math.round(fh * H)));
      var d = ctx.getImageData(x0, y0, w, h).data;
      var sum = 0, n = 0;
      for (var i = 0; i < d.length; i += 4) {
        // Les images sont affichées sur FOND BLANC (background-color:#fff sur
        // .product-media__image). On COMPOSE donc chaque pixel sur blanc :
        // une zone transparente compte comme BLANCHE (lum 1), pas ignorée.
        // -> sur un packshot détouré, le fond sous la barre est bien vu comme
        //    clair et la barre passe en sombre correctement.
        var a = d[i + 3] / 255;
        var pl = (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255;
        sum += a * pl + (1 - a);   // composé sur blanc (transparent -> 1)
        n++;
      }
      var lum = n ? sum / n : null;
      _lumCache[key] = lum;
      return lum;
    } catch (e) { return null; }   // canvas bloqué -> on ne touche pas à la couleur
  }

  /* Images de la variante sélectionnée, déduites du TEXTE ALTERNATIF :
     une image dont l'alt correspond à un nom de variante n'est gardée que si
     c'est la variante affichée ; les autres (alt neutre) sont communes à
     toutes les variantes. C'est cette liste qui définit le nombre de segments
     de la barre — indépendamment de ce que le thème a pu re-poser. */
  function variantSlides() {
    var sel = selectedVariant(), noms = variantNamesArr();
    return slidesArr().filter(function (sl) {
      var v = varianteDeLaSlide(sl, noms);
      return !v || v === sel;   // commune OU la variante sélectionnée
    });
  }

  var _progIndex = 0;
  /* SUIVI EN TEMPS RÉEL du geste.
     Tout ce qui coûte (chercher la barre, compter les images, lire la variante)
     est fait UNE FOIS au début du geste : pendant le mouvement il ne reste
     qu'une écriture de variable CSS, groupée dans un requestAnimationFrame.
     C'était la cause du léger retard : scrubProgress() relançait un
     querySelectorAll complet à chaque événement pointermove/wheel. */
  var _scrubBar = null, _scrubN = 0, _scrubBase = 0, _scrubFrac = 0, _scrubRaf = null;
  function beginScrub() {
    _scrubBar = progressEl();
    if (!_scrubBar) return false;
    _scrubN = visibleSlides().length;
    if (_scrubN < 2) { _scrubBar = null; return false; }
    _scrubBase = _progIndex;
    _scrubFrac = 0;
    _scrubBar.setAttribute('data-scrub', 'true');   // coupe la transition
    return true;
  }
  function scrubProgress(frac) {
    if (!_scrubBar && !beginScrub()) return;
    _scrubFrac = frac;
    if (_scrubRaf) return;                          // 1 seule écriture par frame
    _scrubRaf = window.requestAnimationFrame(function () {
      _scrubRaf = null;
      if (!_scrubBar) return;
      // Un geste ne fait avancer QUE d'une image : la barre ne doit donc jamais
      // dépasser l'image suivante (ni la précédente), sinon elle part trop loin
      // puis "revient" au relâchement. On borne la course à ±1 segment.
      var step = Math.max(-1, Math.min(1, _scrubFrac));
      var raw = _scrubBase + step, max = _scrubN - 1;
      // et on reste dans la piste (le bouclage se fait d'un coup, pas en glissant)
      _scrubBar.style.setProperty('--fm-prog-p', Math.max(0, Math.min(max, raw)));
    });
  }
  /* Fin du geste : on rend la main à la transition (elle rejoint l'index). */
  function endScrub() {
    if (_scrubRaf) { window.cancelAnimationFrame(_scrubRaf); _scrubRaf = null; }
    if (_scrubBar) _scrubBar.removeAttribute('data-scrub');
    _scrubBar = null;
  }
  function progressEl() {
    var media = mediaEl();
    if (!media) return null;
    var bar = media.querySelector('.fm-progress');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'fm-progress';
      bar.innerHTML = '<span class="fm-progress__fill"></span>';
      // clic sur un segment -> on va directement à cette image
      bar.addEventListener('click', function (e) {
        var vis = visibleSlides();
        if (vis.length < 2) return;
        var r = bar.getBoundingClientRect();
        var i = Math.floor(((e.clientX - r.left) / r.width) * vis.length);
        i = Math.max(0, Math.min(vis.length - 1, i));
        var curI = vis.indexOf(activeSlide());
        if (vis[i] !== activeSlide()) setActive(vis[i], true, i < curI ? -1 : 1);
      });
      media.appendChild(bar);
    }
    return bar;
  }
  /* @param {Element} [target] slide visée — indispensable pendant le balayage :
     l'ancienne et la nouvelle portent toutes deux .fm-active pendant WIPE_MS,
     et activeSlide() renverrait alors l'ANCIENNE (barre bloquée / qui saute). */
  /* @param {boolean} [fige] true = on repositionne SANS transition.
     Sert aux sauts qui ne sont pas un balayage : changement de teinte,
     re-filtrage de la galerie. Sans ça, le segment GLISSE de son ancien
     index vers le nouveau pendant que le thème reconstruit la galerie —
     c'est la barre qui « avance un peu en buggant ». */
  function updateProgress(target, fige) {
    try {
      var media = mediaEl(), bar = progressEl();
      if (!media || !bar) return;
      var vis = visibleSlides();
      var cur = target || activeSlide() || firstVisibleSlide();
      bar.setAttribute('data-single', vis.length < 2 ? 'true' : 'false');
      if (vis.length < 2 || !cur) return;
      var i = vis.indexOf(cur);
      if (i < 0) i = 0;
      var prevI = _progIndex, n = vis.length;
      _progIndex = i;
      bar.style.setProperty('--fm-prog-n', n);
      if (fige) {
        /* Saut sans balayage : on coupe la transition le temps d'écrire.
           On passe AVANT le test `data-scrub` ci-dessous, sinon un geste en
           cours empêcherait l'écriture et la barre resterait sur l'ancien
           index après un changement de teinte. */
        bar.setAttribute('data-scrub', 'true');
        bar.style.setProperty('--fm-prog-p', i);
        void bar.offsetWidth;                            // applique tout de suite
        bar.removeAttribute('data-scrub');
      } else if (!bar.hasAttribute('data-scrub')) {
        // bouclage (dernière -> première, ou l'inverse) : on repositionne SANS
        // transition, sinon le segment traverse toute la piste à contresens.
        var wraps = n > 2 && ((prevI === n - 1 && i === 0) || (prevI === 0 && i === n - 1));
        if (wraps) {
          bar.setAttribute('data-scrub', 'true');       // coupe la transition
          bar.style.setProperty('--fm-prog-p', i);
          void bar.offsetWidth;                          // applique tout de suite
          bar.removeAttribute('data-scrub');
        } else {
          bar.style.setProperty('--fm-prog-p', i);
        }
      }
      // on colle la barre au bas de l'IMAGE (et pas de la colonne)
      var img = cur.querySelector('.product-media__image');
      if (!img) return;
      var r = img.getBoundingClientRect(), mr = media.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var w = Math.round(r.width * PROG_W);
      var left = Math.round(r.left - mr.left + (r.width - w) / 2);
      var top = Math.round(r.top - mr.top + r.height - PROG_INSET);
      bar.style.left = left + 'px';
      bar.style.width = w + 'px';
      bar.style.top = top + 'px';
      bar.setAttribute('data-ready', 'true');
      // COULEUR : luminance du rectangle exactement situé sous la barre
      var barH = bar.offsetHeight || 2;
      var lum = luminanceAt(
        img,
        (left - (r.left - mr.left)) / r.width,
        (top - (r.top - mr.top) - barH) / r.height,   // un poil au-dessus : on lit le fond, pas le trait
        w / r.width,
        (barH * 3) / r.height
      );
      if (lum === null) {
        // image pas encore décodée -> on refait le calcul dès qu'elle arrive
        if (!img._fmLumWait) {
          img._fmLumWait = true;
          img.addEventListener('load', function () { updateProgress(); }, { once: true });
        }
      } else {
        bar.setAttribute('data-dark', lum > PROG_LUM_MAX ? 'true' : 'false');
      }
    } catch (e) { /* la barre ne doit jamais bloquer la galerie */ }
  }

  /* ---- actif + BALAYAGE ---------------------------------------------- */
  function updateThumbHighlight(slide) {
    var i = slidesArr().indexOf(slide);
    thumbsArr().forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
    dotsArr().forEach(function (d, j) {
      var b = d.querySelector('button'); if (b) b.setAttribute('aria-selected', j === i ? 'true' : 'false');
    });
  }
  /* @param {number} [dir] +1 = on avance, -1 = on recule. Le balayage part du
     côté correspondant : vers l'avant l'image se dévoile de la droite vers la
     gauche, en arrière c'est l'inverse. */
  function setActive(slide, animate, dir) {
    if (!slide) return;
    var prev = activeSlide();
    slidesArr().forEach(function (s) { if (s !== slide && s !== prev) s.classList.remove('fm-active', 'fm-enter', 'fm-back'); });
    slide.classList.add('fm-active');
    if (animate) {
      slide.classList.remove('fm-enter', 'fm-back');
      void slide.offsetWidth;
      if (dir < 0) slide.classList.add('fm-back');
      slide.classList.add('fm-enter');
      window.setTimeout(function () {
        slide.classList.remove('fm-enter', 'fm-back');
        if (prev && prev !== slide) prev.classList.remove('fm-active');
        removeFreeze();   // le balayage est fini : on retire l'ancienne image figée
        updateProgress(slide);   // re-calage une fois l'ancienne slide libérée
      }, WIPE_MS);
    } else if (prev && prev !== slide) {
      prev.classList.remove('fm-active');
    }
    updateThumbHighlight(slide);
    /* `animate` dit si l'IMAGE est balayée ; la barre suit la même règle.
       Changement de teinte et re-filtrage passent ici avec animate = false :
       la barre se repose d'un coup au lieu de glisser. */
    updateProgress(slide, !animate);
    setHeroImg();
  }

  /* ---- filtre (AFFICHAGE seulement) + garde-fou d'actif -------------- */
  function filterGallery() {
    var slides = slidesArr();
    if (!slides.length) return;
    var thumbs = thumbsArr(), dots = dotsArr();
    var sel = selectedVariant(), noms = variantNamesArr();
    slides.forEach(function (slide, i) {
      var v = varianteDeLaSlide(slide, noms);
      var show = !v || v === sel;   // commune OU la variante sélectionnée
      slide.style.display = show ? '' : 'none';
      if (thumbs[i]) thumbs[i].style.display = show ? '' : 'none';
      if (dots[i])   dots[i].style.display   = show ? '' : 'none';
    });
  }
  // s'assure qu'une image (la bonne) est active — SANS balayage
  function ensureActive() {
    var act = activeSlide();
    if (act && act.style.display !== 'none') { updateThumbHighlight(act); updateProgress(act, true); return; }
    setActive(featuredSlideForVariant() || firstVisibleSlide(), false);
  }

  /* ---- PRÉCHARGEMENT : charge en fond toutes les images de la galerie pour
     que le changement de variante soit INSTANTANÉ (pas d'attente réseau au
     clic). On repasse les <img loading="lazy"> en "eager". -------------- */
  function preloadGallery() {
    slidesArr().forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      if (img.loading === 'lazy') {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'low');   // en fond, ne gêne pas le reste
      }
      // force le cache à la MÊME résolution que la galerie (srcset + sizes)
      if (!img._fmPre) {
        img._fmPre = true;
        var pre = new Image();
        try { pre.fetchPriority = 'low'; } catch (e) {}
        var ss = img.getAttribute('srcset'), sz = img.getAttribute('sizes');
        if (sz) pre.sizes = sz;
        if (ss) pre.srcset = ss;
        pre.src = img.currentSrc || img.getAttribute('src') || '';
      }
    });
  }

  /* ---- GLISSER À LA SOURIS : passer d'une image à l'autre ------------- */
  // slides visibles (celles de la variante) dans l'ordre du DOM
  function visibleSlides() {
    var all = slidesArr();
    var vis = all.filter(function (s) { return s.style.display !== 'none'; });
    // si le filtrage par ALT n'a pas encore tourné (galerie fraîchement
    // re-rendue par le thème), on le calcule à la volée : la barre et la
    // navigation restent d'accord sur la même liste, toujours.
    if (vis.length === all.length) return variantSlides();
    return vis.length ? vis : variantSlides();
  }
  // avance (dir=+1) ou recule (dir=-1) d'une image parmi les visibles (boucle)
  function goRel(dir) {
    var vis = visibleSlides();
    if (vis.length < 2) return;
    var idx = vis.indexOf(activeSlide());
    if (idx < 0) idx = 0;
    var n = (idx + dir + vis.length) % vis.length;
    setActive(vis[n], true, dir);
  }
  var DRAG_THRESH = 45;    // px de glissement mini pour changer d'image
  var DRAG_FULL = 260;     // px correspondant à UN segment de barre (suivi en direct)
  function setupDrag() {
    var media = mediaEl();
    if (!media || media._fmDrag) return;
    media._fmDrag = true;
    media.style.cursor = 'grab';
    var startX = 0, startY = 0, dragging = false;

    function onDown(e) {
      if (e.button !== undefined && e.button !== 0) return;         // clic gauche seulement
      if (e.target.closest('.slideshow-controls__thumbnail')) return; // pas sur les vignettes
      dragging = true; startX = e.clientX; startY = e.clientY;
      media.style.cursor = 'grabbing';
    }
    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) < Math.abs(dy)) return;
      // la barre suit le doigt : DRAG_FULL px = un segment complet
      if (!_scrubBar && !beginScrub()) return;
      scrubProgress(-dx / DRAG_FULL);
    }
    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      media.style.cursor = 'grab';
      endScrub();                 // la transition reprend la main
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) >= DRAG_THRESH && Math.abs(dx) > Math.abs(dy)) {
        goRel(dx < 0 ? 1 : -1);   // glisse vers la GAUCHE -> image suivante
      } else {
        updateProgress();         // geste trop court : la barre revient en place
      }
    }
    media.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', function () { dragging = false; media.style.cursor = 'grab'; endScrub(); updateProgress(); });
    // empêche le "fantôme" de l'image traînée + la sélection de texte
    media.addEventListener('dragstart', function (e) { e.preventDefault(); });
    setupWheelSwipe();
  }

  /* ---- TRACKPAD : glissement HORIZONTAL à 2 doigts -> image suivante ----
     On ne réagit QUE si le geste est majoritairement horizontal (le scroll
     vertical de la page reste intact), et on bloque le "retour arrière" du
     navigateur avec preventDefault.

     Un geste 2 doigts = UNE image, quelle que soit la force.
     Le trackpad continue d'envoyer une longue traîne d'inertie après le geste ;
     tout l'enjeu est de la reconnaître. Détecter une "remontée d'amplitude" ne
     suffit pas : l'inertie macOS n'est pas régulière, elle sursaute, et ces
     sursauts étaient pris pour de nouveaux gestes -> 3 images d'un coup.
     Règle retenue, bien plus sûre : après un changement d'image, le geste est
     terminé — on ignore tout jusqu'au silence de fin de geste. Seule exception,
     une inversion de sens : l'inertie ne s'inverse jamais, donc c'est
     forcément un nouveau geste. Et par sécurité, jamais deux images à moins de
     WHEEL_MIN_GAP l'une de l'autre.
     Réglages : WHEEL_FULL    = course (px) pour déclencher une image
                WHEEL_MIN_GAP = délai mini (ms) entre deux images
                WHEEL_END     = silence (ms) qui marque la fin d'un geste */
  var WHEEL_FULL = 80;
  var WHEEL_END = 130;
  var WHEEL_MIN_GAP = 200;
  var _wOff = 0, _wEnd = null, _wLock = false, _wDir = 1, _wLast = 0;
  var _wPeak = 0, _wValley = false;
  function setupWheelSwipe() {
    var media = mediaEl();
    if (!media || media._fmWheel) return;
    media._fmWheel = true;
    media.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   // geste vertical : on laisse passer
      e.preventDefault();                                     // pas de navigation arrière
      var ad = Math.abs(e.deltaX);

      // fin de geste : plus aucun événement pendant WHEEL_END -> remise à zéro
      clearTimeout(_wEnd);
      _wEnd = setTimeout(function () {
        _wOff = 0; _wLock = false; _wPeak = 0; _wValley = false;
        endScrub();
        updateProgress();
      }, WHEEL_END);

      if (_wLock) {
        // Image déjà changée pour CE geste : on ignore le reste, inertie
        // comprise, et surtout on ne re-scrube pas (sinon la barre dérive).
        // MAIS il faut pouvoir réenchaîner un vrai geste sans attendre la fin
        // de l'inertie, sinon ça "bloque" et il faut glisser plusieurs fois.
        // Signature d'une nouvelle poussée, fiable : l'amplitude est d'abord
        // RETOMBÉE nettement (creux) puis REMONTE. L'inertie, elle, décroît :
        // ses sursauts ne repassent jamais au-dessus après un vrai creux.
        if ((e.deltaX > 0) !== (_wDir > 0)) {
          _wLock = false; _wOff = 0;               // sens inversé = nouveau geste
        } else {
          if (ad < _wPeak * 0.25) _wValley = true;
          if (_wValley && ad > 8 && ad > _wPeak * 0.35) {
            _wLock = false; _wOff = 0; _wPeak = 0; _wValley = false;
          } else {
            return;
          }
        }
      }
      if (ad > _wPeak) _wPeak = ad;                // amplitude max du geste

      if (!_scrubBar) beginScrub();   // sans bloquer le geste si la barre manque
      _wOff += e.deltaX / WHEEL_FULL;

      if (Math.abs(_wOff) >= 1) {
        var now = Date.now();
        if (now - _wLast < WHEEL_MIN_GAP) {        // garde-fou : jamais 2 images collées
          _wOff = _wOff > 0 ? 1 : -1;
          return;
        }
        _wDir = _wOff > 0 ? 1 : -1;
        _wOff = 0;
        _wLock = true;                             // UNE seule image par geste
        _wValley = false;                          // il faudra un creux avant de repartir
        _wLast = now;
        endScrub();                                // la transition reprend la main
        goRel(_wDir);                              // 2 doigts vers la GAUCHE -> image suivante
      } else {
        scrubProgress(_wOff);                      // suivi en temps réel avant la bascule
      }
    }, { passive: false });
  }

  /* ---- déclencheurs -------------------------------------------------- */
  ready(function () {
    sizeHero();
    filterGallery();
    ensureActive();
    setupDrag();
    updateDiscountBadge();
    formatRatingCount();
    setupExclusiveAccordion();
    filterComposition();
    // (la barre « ajouter au panier » sticky est gérée par le CSS + le thème)
    setTimeout(function () { sizeHero(); filterGallery(); ensureActive(); setupDrag(); updateDiscountBadge(); formatRatingCount(); setupExclusiveAccordion(); filterComposition(); updateProgress(); }, 300);
    setTimeout(function () { sizeHero(); filterGallery(); ensureActive(); setupDrag(); updateDiscountBadge(); formatRatingCount(); setupExclusiveAccordion(); filterComposition(); updateProgress(); }, 1000);
    // précharge la galerie en fond -> changement de variante instantané
    setTimeout(preloadGallery, 600);
    setTimeout(preloadGallery, 2500);   // rattrape les images (re)posées par le thème

    // clic miniature -> BALAYAGE (court-circuite le select() du thème)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('#MainContent .slideshow-controls__thumbnail');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var i = thumbsArr().indexOf(btn);
      if (i >= 0) {
        var all = slidesArr();
        setActive(all[i], true, i < all.indexOf(activeSlide()) ? -1 : 1);
      }
    }, true);

    // élément stable (survit au re-render du thème) : sert de support à la
    // classe "occupé" qui masque proprement galerie + vignettes pendant que
    // le thème régénère tout (sinon les vignettes clignotent quelques secondes).
    var pinfo = document.querySelector('#MainContent .product-information');
    function setBusy(on) { if (pinfo) pinfo.classList.toggle('fm-busy', !!on); }

    // Le thème place l'image "featured" de la variante en TÊTE (slide 0), mais
    // il la met à jour en DEUX TEMPS. Il ne faut donc pas balayer tant que la
    // slide 0 ne correspond pas encore à la variante sélectionnée : sinon on
    // balaie une image périmée (2e image) avant que le thème ne pose la bonne.
    var pollT = null, maxT = null, freezeT = null;

    // retire l'image figée au plus tard après ~1.6s (sécurité si le thème ne
    // remplace jamais la galerie). Normalement l'observer synchrone la retire dès
    // que la nouvelle galerie est posée.
    function scheduleUnfreeze() {
      clearTimeout(freezeT);
      freezeT = setTimeout(removeFreeze, 700);
    }

    function doVariantWipe() {
      clearTimeout(pollT); clearTimeout(maxT);
      changing = false;
      filterGallery();
      var slides = slidesArr(), sel = selectedVariant();
      // cible = la featured du thème (slide 0) si elle correspond, sinon repli
      var target = (slides[0] && varianteDeLaSlide(slides[0]) === sel) ? slides[0]
                 : (featuredSlideForVariant() || firstVisibleSlide());
      if (target) setActive(target, false);  // changement de variante = SANS transition
      removeFreeze();                         // révèle la nouvelle image tout de suite
      setBusy(false);                         // on réaffiche les vignettes
      updateDiscountBadge();                  // le prix change selon la variante
      filterComposition();                    // compo : lignes de la nouvelle variante
    }

    // attend que la featured de la variante soit dispo (repli si pas déjà là)
    function waitFeatured(expected, tries) {
      tries = tries || 0;
      if (selectedVariant() !== expected) return;   // variante re-changée entre-temps
      /* ON ATTEND LA DIAPOSITIVE 0, et rien d'autre. La version précédente
         repartait dès qu'UNE diapositive portait le nom de la teinte — or il y
         en a toujours une (le mannequin), même avant le re-rendu. L'attente ne
         servait donc à rien : on balayait immédiatement sur la mauvaise image.
         La diapositive 0 n'est juste qu'une fois le thème passé. */
      var s0 = slidesArr()[0];
      if ((s0 && varianteDeLaSlide(s0) === expected) || tries > 16) {   // ~0.8s max
        doVariantWipe();
        return;
      }
      pollT = setTimeout(function () { waitFeatured(expected, tries + 1); }, 50);
    }

    document.addEventListener('change', function (e) {
      if (!(e.target.closest && e.target.closest('#MainContent variant-picker'))) return;
      changing = true;
      var sel = selectedVariant();
      showFreeze();        // fige l'image ACTUELLE : elle COUVRE tout le changement
      filterGallery();     // montre déjà les slides de la nouvelle variante
      clearTimeout(pollT); clearTimeout(maxT);

      /* LE RACCOURCI NE VAUT QUE SI LE THÈME A DÉJÀ MIS LA GALERIE À JOUR.
         Avant, on prenait ici `featuredSlideForVariant()`, c'est-à-dire la
         PREMIÈRE diapositive dont le texte alternatif porte le nom de la
         teinte. Mesuré sur la vraie galerie, c'était faux : seul le packshot
         de la teinte AFFICHÉE est présent, posé en tête par le thème. Les
         autres teintes n'ont que leur photo mannequin et leur texture. Au clic
         sur Cinnamon, la première correspondance dans l'ancien DOM était donc
         `Belinda_-_Cinnamon.webp`, le MANNEQUIN — on l'affichait, puis le
         thème reposait sa galerie avec le packshot et l'image changeait.
         D'où la 2e image pendant une seconde, puis la 1re.

         LE SEUL SIGNAL FIABLE est donc : la diapositive 0 porte-t-elle déjà la
         teinte demandée ? C'est le thème qui l'y met, et il ne le fait qu'une
         fois sa galerie régénérée. Tant que ce n'est pas le cas, on ne devine
         pas : l'image figée garde l'ANCIENNE photo, qui est juste, le temps
         que la bonne arrive. Mieux vaut une image d'avant pendant 300ms qu'une
         mauvaise image de la bonne teinte pendant une seconde. */
      var slides0 = slidesArr();
      var target = (slides0[0] && varianteDeLaSlide(slides0[0]) === sel) ? slides0[0] : null;
      if (target) {
        setActive(target, false);     // bascule sur la nouvelle image (sous la freeze)
        showFreeze();                 // re-fige : la freeze montre la NOUVELLE image
        setBusy(false);
        updateDiscountBadge();
        filterComposition();
        changing = false;
      } else {
        // featured pas trouvée : on garde la freeze (ancienne image) le temps que
        // le thème pose la galerie ; le swap fournira la bonne image (observer sync).
        setBusy(false);               // pas de masquage : la freeze couvre déjà
        maxT = setTimeout(doVariantWipe, 1200);
        waitFeatured(sel, 0);
      }
      // La freeze reste posée -> elle masque le remplacement du <media-gallery>
      // par le thème (fini le clignotement des vignettes / le saut d'image).
      // L'observer synchrone la retire une fois la nouvelle galerie en place ;
      // sinon ce filet la retire au plus tard après 1.6s.
      scheduleUnfreeze();
    });

    // re-render du thème. Au changement de variante, le thème REMPLACE tout le
    // <media-gallery>. Si on laisse notre JS se ré-appliquer en différé (60ms),
    // la nouvelle galerie s'affiche "brute" pendant une frame -> décalage.
    // -> On la retraite SYNCHRONE (dans le callback, avant le repaint) dès
    //    qu'un nouveau <media-gallery> est injecté. Images préchargées = instant.
    var root = pinfo || main;
    if (root) {
      var t = null;
      new MutationObserver(function (muts) {
        var galleryAdded = muts.some(function (m) {
          return [].some.call(m.addedNodes, function (n) {
            if (n.nodeType !== 1) return false;
            return n.tagName === 'MEDIA-GALLERY' || n.tagName === 'SLIDESHOW-COMPONENT' ||
                   n.tagName === 'SLIDESHOW-SLIDES' || n.tagName === 'SLIDESHOW-SLIDE' ||
                   (n.querySelector && n.querySelector('media-gallery, slideshow-slide'));
          });
        });
        if (galleryAdded) {
          // SYNCHRONE : pas de frame non traitée -> pas de décalage.
          filterGallery();
          ensureActive();
          setupDrag();
          updateProgress(null, true);   // reconstruction, pas un balayage : aucune transition
          // on retire l'image figée seulement APRÈS que la nouvelle galerie soit
          // mise en page (frame suivante) -> aucun état transitoire visible.
          requestAnimationFrame(function () { requestAnimationFrame(removeFreeze); });
        }
        clearTimeout(t);
        t = setTimeout(function () {
          sizeHero();
          filterGallery();
          updateDiscountBadge();
          formatRatingCount();
          setupExclusiveAccordion();
          filterComposition();
          updateProgress(null, true);      // barre de défilement de la galerie (recalage sec)
          preloadGallery();               // re-précharge les images (re)posées par le thème
          if (!changing) ensureActive();
        }, 60);
      }).observe(root, { childList: true, subtree: true });
    }

    // barre sticky (hors .product-information) : re-injecte le badge quand elle
    // apparaît / se met à jour au changement de variante
    var sticky = document.querySelector('sticky-add-to-cart');
    if (sticky) {
      var st = null;
      new MutationObserver(function () {
        clearTimeout(st);
        st = setTimeout(updateDiscountBadge, 60);
      }).observe(sticky, { childList: true, subtree: true });
    }
  });

  window.addEventListener('load', function () { sizeHero(); filterGallery(); if (!changing) ensureActive(); updateProgress(); });
  var rt = null;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { sizeHero(); updateProgress(); }, 150); });
})();


/* ==========================================================================
   PAGE PRODUIT — MOBILE : TITRE défilant (marquee en transform)
   Largeur de la boîte verrouillée sur la colonne d'infos + glissement du titre
   en translateX. Va-et-vient. Bord gauche estompé quand glissé, droit tant
   qu'il reste du texte. Réglages : TITLE_START, TITLE_SPEED (ms/px), PAUSE_*.
   ========================================================================== */
(function () {
  var main = document.getElementById('MainContent');
  if (!main || (main.getAttribute('data-template') || '').indexOf('product') !== 0) return;

  var TITLE_START = 1500, TITLE_SPEED = 25, PAUSE_END = 1200, PAUSE_LOOP = 2500;

  function isMobile() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; }

  function setup() {
    if (!isMobile()) return;
    var pd = main.querySelector('.product-details');
    var h5 = main.querySelector('.product-details h5');
    if (!pd || !h5) return;
    var box = h5.closest('.text-block');
    if (!box || box.__fmTitle) return;
    box.__fmTitle = true;

    h5.style.setProperty('white-space', 'nowrap', 'important');
    h5.style.setProperty('display', 'inline-block', 'important');
    h5.style.setProperty('max-width', 'none', 'important');
    h5.style.setProperty('width', 'auto', 'important');
    h5.style.setProperty('will-change', 'transform');

    function lockWidth() {
      var avail = pd.clientWidth;
      box.style.setProperty('display', 'block', 'important');
      box.style.setProperty('flex', '0 0 auto', 'important');
      box.style.setProperty('min-width', '0', 'important');
      box.style.setProperty('width', avail + 'px', 'important');
      box.style.setProperty('max-width', avail + 'px', 'important');
      box.style.setProperty('overflow', 'hidden', 'important');
      box.style.setProperty('position', 'relative', 'important');
      return avail;
    }
    lockWidth();

    var tx = 0;
    function over() { return Math.max(0, h5.scrollWidth - box.clientWidth); }

    function apply(x) {
      tx = x;
      h5.style.transform = 'translateX(' + x + 'px)';
      var mx = over();
      var fadeL = -x > 2;
      var fadeR = -x < mx - 2;
      var left  = fadeL ? 'transparent 0, #000 8%' : '#000 0, #000 0';
      var right = fadeR ? '#000 92%, transparent 100%' : '#000 100%, #000 100%';
      var m = 'linear-gradient(90deg, ' + left + ', ' + right + ')';
      box.style.webkitMaskImage = m;
      box.style.maskImage = m;
    }
    apply(0);

    function animateTo(target, duration, done) {
      var start = tx, delta = target - start, t0 = performance.now();
      if (Math.abs(delta) < 1) { if (done) done(); return; }
      (function step(now) {
        var p = Math.min(1, (now - t0) / duration);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        apply(start + delta * e);
        if (p < 1) requestAnimationFrame(step); else if (done) done();
      })(t0);
    }

    function loop() {
      if (!isMobile()) { setTimeout(loop, 1500); return; }
      var mx = over();
      if (mx < 4) { apply(0); setTimeout(loop, 2000); return; }
      var dur = Math.max(1400, mx * TITLE_SPEED);
      animateTo(-mx, dur, function () {
        setTimeout(function () {
          animateTo(0, dur, function () { setTimeout(loop, PAUSE_LOOP); });
        }, PAUSE_END);
      });
    }

    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { lockWidth(); apply(tx); }); }
    window.addEventListener('resize', function () { lockWidth(); apply(0); });
    setTimeout(loop, TITLE_START);
  }

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    setup();
    setTimeout(setup, 600);
    setTimeout(setup, 1600);
  });
})();



/* Couleur dominante de la photo produit -> --fm-glow-color (halo infos) */
(function () {
  function parseUrl(v){ var m=(v||'').match(/url\(["']?(.*?)["']?\)/); return m ? m[1] : ''; }
  function activeUrl(){
    var pd = document.querySelector('.product-details');
    if (pd){
      var u = parseUrl(getComputedStyle(pd).getPropertyValue('--fm-glow-img'));
      if (u) return u;
    }
    var img = document.querySelector('.product-information__media .product-media__image');
    return img ? (img.currentSrc || img.src) : '';
  }
  var last = '';
  function compute(){
    var pd = document.querySelector('.product-details'); if (!pd) return;
    var url = activeUrl(); if (!url || url === last) return; last = url;
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function(){
      try{
        var n = 24, c = document.createElement('canvas'); c.width = c.height = n;
        var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0, n, n);
        var d = ctx.getImageData(0, 0, n, n).data, r=0,g=0,b=0,k=0;
        for (var i=0;i<d.length;i+=4){
          var R=d[i],G=d[i+1],B=d[i+2],A=d[i+3];
          if (A < 24) continue;                    // transparent
          if (R>238 && G>238 && B>238) continue;   // fond blanc
          r+=R; g+=G; b+=B; k++;
        }
        if (!k){ for (var j=0;j<d.length;j+=4){ r+=d[j]; g+=d[j+1]; b+=d[j+2]; k++; } }
        pd.style.setProperty('--fm-glow-color','rgb('+Math.round(r/k)+' '+Math.round(g/k)+' '+Math.round(b/k)+')');
      } catch(e){}
    };
    im.src = url;
  }
  function schedule(){ requestAnimationFrame(compute); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { attributes:true, subtree:true, attributeFilter:['style','src'] });
  window.addEventListener('load', schedule);
  setTimeout(schedule, 600); setTimeout(schedule, 1500);
})();

/* ============================================================
   GALERIE : hauteur disponible réelle, mesurée
   ------------------------------------------------------------
   Le plafond de la galerie était calculé en CSS à partir de --fm-top-bars,
   c'est-à-dire de sa position une fois COLLÉE (sticky). En haut de page elle
   n'est pas encore collée : elle démarre sous la barre d'annonce, l'en-tête
   et le rembourrage de la section. Le même plafond la faisait donc dépasser
   du bas de la fenêtre tant qu'on n'avait pas scrollé.

   On mesure les deux positions et on garde la plus basse — celle qui
   contraint le plus. Le résultat part dans --fm-galerie-dispo ; le CSS s'en
   sert pour la hauteur ET pour la largeur, le format est conservé.

   ATTENTION à la façon de mesurer la position au repos : getBoundingClientRect()
   ne convient PAS ici. Sur un élément sticky déjà collé, il renvoie la
   position collée, et y rajouter le défilement donne un nombre qui grandit
   à chaque pixel scrollé. Première version : la galerie finissait à 192px
   de large, parce que la hauteur calculée tombait sous le plancher de
   sécurité. On passe donc par offsetTop, qui est une valeur de MISE EN PAGE :
   le sticky ne la déplace pas.
   ============================================================ */
(function () {
  'use strict';

  function media() {
    return document.querySelector('#MainContent .product-information__media');
  }

  /* ============================================================
     POSITION AU REPOS — ON MESURE LE PARENT, PAS LA GALERIE
     ------------------------------------------------------------
     LA PREMISSE QUI ETAIT FAUSSE. La version precedente sommait
     offsetTop sur la galerie elle-meme, en partant du principe que
     « le sticky ne deplace pas offsetTop ». C'est faux : sur un
     element position:sticky, Chrome INCLUT le decalage collant dans
     offsetTop.

     RELEVE sur la fiche produit, en descendant puis en remontant :
       au repos            repos = 164
       apres defilement    repos = 551
       plus loin           repos = 378
     Trois valeurs pour un element qui n'a pas bouge dans la mise en
     page. Comme dispo = innerHeight - repos - marge, la galerie
     retrecissait a chaque fois que repos grimpait — jusqu'a 44x56 au
     plus bas. C'etait le bug « la galerie devient toute petite ».

     LA PARADE. Le PARENT de la galerie n'est pas collant : sa chaine
     d'offsetTop est, elle, une vraie valeur de mise en page, stable
     au defilement. Et la galerie commence en haut de son parent, donc
     c'est bien la position cherchee.

     LE VERROU EN PLUS. Par securite on ne retient une nouvelle mesure
     que lorsque la galerie n'est PAS collee. Si jamais un autre
     mecanisme venait fausser la lecture pendant qu'elle est collee,
     on garde la derniere valeur saine au lieu de la propager.
     ============================================================ */
  var reposConnu = null;

  function hautAuRepos(el) {
    var cible = el.parentElement || el;
    var y = 0, n = cible;
    while (n) { y += n.offsetTop; n = n.offsetParent; }
    return y;
  }

  /* La galerie est-elle actuellement collee en haut ? */
  function estCollee(el, colle) {
    return el.getBoundingClientRect().top <= colle + 1;
  }

  function mesurer() {
    var el = media();
    if (!el) return;

    var cs = getComputedStyle(el);

    var colle = parseFloat(cs.top);              /* position une fois collée */
    if (!isFinite(colle) || colle < 0) colle = 0;

    /* On ne rafraichit la position au repos que si la galerie n'est pas
       collee — et on garde la derniere valeur saine sinon. */
    if (!estCollee(el, colle) || reposConnu === null) {
      reposConnu = hautAuRepos(el);
    }
    var repos = reposConnu;                      /* position en haut de page */
    var haut = Math.max(colle, repos);

    var marge = parseFloat(cs.getPropertyValue('--fm-gallery-marge-bas')) || 15;
    var dispo = Math.round(window.innerHeight - haut - marge);

    /* ============================================================
       PLANCHER — le correctif du 3 oct.
       ------------------------------------------------------------
       LE BUG. La formule ci-dessus dimensionne la galerie pour sa
       position AU REPOS, afin qu'elle tienne entière quand on est en
       haut de page. Correct — mais sans minimum. Sur une fenêtre
       courte elle rétrécit sans fin.

       MESURÉ sur la fiche produit, fenêtre de 550px de haut :
         repos 164 · collée 96,4 · marge 15
         dispo = 550 - 164 - 15 = 371  ->  galerie de 297 x 371
       371 passe au-dessus du garde-fou de 320, la valeur est donc
       appliquée : une galerie minuscule sur un écran de 1440 de large.
       C'est ce que voyait l'utilisateur « des fois » — à chaque fois
       que la fenêtre raccourcit, en fait : outils de développement
       ouverts, petit portable, barre d'adresse qui se rétracte.

       LA RÈGLE. En dessous d'un certain format la galerie ne sert
       plus à rien : mieux vaut qu'elle dépasse un peu en haut de page
       et qu'on fasse défiler. On impose donc un PLANCHER.

       Mais le plancher ne doit jamais dépasser la place disponible
       une fois la galerie COLLÉE, sinon son bas serait coupé en
       permanence — ce qui serait pire que trop petit. D'où le
       `Math.min` : on ne monte jamais au-dessus de l'espace réel.

       Résultat sur la même page, selon la hauteur de fenêtre :
         550px -> 439 au lieu de 371  (galerie 351 au lieu de 297)
         650px -> 525 au lieu de 471
         800px et plus -> inchangé, le plancher ne sert plus.
       ============================================================ */
    var PLANCHER = 525;                       /* 525 x 0,8 = 420px de large */
    var placeCollee = Math.round(window.innerHeight - colle - marge);
    dispo = Math.max(dispo, Math.min(PLANCHER, placeCollee));

    /* Mesure aberrante (page pas encore posée, écran minuscule) : on retire
       la variable plutôt que d'imposer une valeur. Le CSS retombe alors sur
       son propre calcul, qui est imparfait mais jamais absurde. */
    if (!isFinite(dispo) || dispo < 320) {
      el.style.removeProperty('--fm-galerie-dispo');
      var m0 = document.getElementById('MainContent');
      if (m0) m0.style.removeProperty('--fm-galerie-dispo');
      return;
    }

    /* Posée sur la galerie ET sur #MainContent : la GRILLE en a besoin pour
       dimensionner la colonne de gauche et centrer l'ensemble. */
    el.style.setProperty('--fm-galerie-dispo', dispo + 'px');
    var main = document.getElementById('MainContent');
    if (main) main.style.setProperty('--fm-galerie-dispo', dispo + 'px');
  }

  var enAttente = false;
  function programmer() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () { enAttente = false; mesurer(); });
  }

  function init() {
    if (!document.querySelector('#MainContent[data-template^="product"]')) return;
    mesurer();
    window.addEventListener('resize', programmer);
    window.addEventListener('orientationchange', function () { setTimeout(mesurer, 120); });
    window.addEventListener('load', programmer);
    /* La hauteur de l'en-tête bouge encore après le premier rendu (polices,
       barre d'annonce) : on repasse deux fois. */
    setTimeout(mesurer, 500);
    setTimeout(mesurer, 1600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ==========================================================================
   LE PANNEAU QUI SE POSE — fiche produit, PORTABLE uniquement
   --------------------------------------------------------------------------
   Ce bloc n'ecrit qu'UNE SEULE CHOSE : --fm-pdp-pose sur <body>, un nombre
   entre 0 et 1. Toute la mise en page est en CSS (product.css §14) :
       0 = haut de page, le panneau mord de 40px sur la photo, 45px de marge
       1 = pose, 10px d'ecart et 10px de marge, comme avant

   LA COURBE. Le rapport brut defilement/300 donne un geste mecanique : le
   panneau demarre aussi vite qu'il finit. On passe donc par un lissage
   (p*p*(3-2p), la « smoothstep ») : derivee nulle aux deux bouts, donc
   depart doux et arrivee douce, sans a-coup au moment ou il se pose.

   POURQUOI PAS DE TRANSITION CSS. Le curseur suit le doigt image par image.
   Une transition par-dessus ajouterait un retard : on arreterait de faire
   defiler et le panneau continuerait de bouger pendant 300ms. La douceur
   doit venir de la courbe, pas d'un delai.

   LE rAF N'EST PAS UNE COQUETTERIE. L'evenement scroll se declenche bien
   plus souvent que le navigateur ne repeint. Ecrire la variable a chaque
   evenement, c'est demander un recalcul de mise en page plusieurs fois pour
   une seule image affichee — et sur un telephone ca se voit. On ne garde
   donc qu'une ecriture par image.

   PORTABLE SEULEMENT, meme borne que le CSS (750px), et suivie en direct :
   une rotation d'ecran rebascule sans rechargement. Sur ordi on remet 1,
   c'est-a-dire l'etat pose, qui est la mise en page d'origine.
   ========================================================================== */
(function () {
  'use strict';

  var main = document.getElementById('MainContent');
  if (!main) return;
  if ((main.getAttribute('data-template') || '').indexOf('product') !== 0) return;

  /* LE CSS SAIT-IL LE FAIRE TOUT SEUL ?
     Si `animation-timeline: scroll()` est supporte, product.css pilote le
     geste depuis le compositeur et ce bloc n'a plus rien a faire par image.
     Il garde UNE tache : le facteur d'echelle, que calc() ne sait pas
     calculer (impossible de diviser deux longueurs). Mais celui-la ne change
     qu'au redimensionnement, pas a chaque image.
     On ne s'abonne donc pas au defilement : laisser tourner les deux ferait
     travailler le fil principal pour rien, et c'est precisement ce qu'on
     cherche a supprimer. */
  var compositeur = typeof CSS !== 'undefined' && CSS.supports &&
                    CSS.supports('animation-timeline', 'scroll()');

  var verrouille = false;                            /* voir « LE VERROU » plus bas */
  var COURSE = 300;                                  /* la transition se joue sur 300px */
  var COTE_DEPART = 45;                              /* doit suivre --fm-pdp-cote-depart (product.css §14) */
  var portable = window.matchMedia('(max-width: 750px)');
  var attendu = false;
  var dernier = -1;

  function poser(v) {
    if (v === dernier) return;                       /* rien n'a change : on n'ecrit pas */
    dernier = v;
    document.body.style.setProperty('--fm-pdp-pose', v);
  }

  /* L'ECHELLE DU DEPART.
     Le panneau est pose a 10px de marge, donc large de (ecran - 20). Au
     depart on le veut a COTE_DEPART de marge, donc large de
     (ecran - 2 x COTE_DEPART). Le rapport des deux est le facteur de scale.
     Il est calcule ICI parce que calc() ne sait pas diviser deux longueurs :
     `calc((100vw - 90px) / (100vw - 20px))` n'existe pas en CSS.
     Recalcule au redimensionnement, donc a la rotation de l'ecran aussi. */
  function echelle() {
    var L = document.documentElement.clientWidth;
    var pose = L - 20;
    if (pose <= 0) return;
    var depart = L - 2 * COTE_DEPART;
    document.body.style.setProperty('--fm-pdp-echelle', Math.round(depart / pose * 10000) / 10000);
  }

  function calculer() {
    attendu = false;
    if (verrouille) { poser(1); return; }
    if (!portable.matches) { poser(1); return; }

    var y = window.scrollY || window.pageYOffset || 0;
    var p = y / COURSE;
    if (p < 0) p = 0;
    else if (p > 1) p = 1;

    p = p * p * (3 - 2 * p);                         /* lissage */
    poser(Math.round(p * 1000) / 1000);              /* 3 decimales suffisent */
  }

  function auDefilement() {
    if (attendu) return;
    attendu = true;
    window.requestAnimationFrame(calculer);
  }

  function auRedimensionnement() {
    echelle();
    if (!compositeur) auDefilement();
  }

  /* LE VERROU — le geste ne se joue qu'UNE FOIS.
     Une animation liee au defilement suit la position : en remontant, elle se
     rejoue a l'envers et le panneau reviendrait chevaucher la photo. On pose
     donc un attribut des que la course est franchie, et product.css coupe les
     animations a partir de la.

     CE GUETTEUR SE SUPPRIME LUI-MEME. Une fois l'attribut pose, il n'y a plus
     rien a surveiller : on retire l'ecouteur. C'est la seule chose que ce
     bloc demande au fil principal quand le compositeur joue le geste, et elle
     s'arrete apres le premier passage.

     Il tourne AUSSI dans la version JS : la logique est la meme, et
     `calculer` s'arrete de son cote une fois verrouille. */
  /* ARME : le verrou n'a le droit de se poser que si on est PASSE par le haut
     depuis la derniere fois. Sans ce garde-fou, relacher le verrou en bas de
     page puis faire remonter la page le reposerait instantanement : la
     remontee traverse la zone des 300px, l'ecouteur s'y declenche, et on
     n'aurait jamais vu le geste. Mesure a l'appui : sans `arme`, le verrou
     restait sur « fini » apres le clic sur une teinte. */
  var arme = true;

  function verrouiller() {
    var y = window.scrollY || window.pageYOffset || 0;
    if (y < COURSE) { arme = true; return; }     /* on est revenu en haut : on rearme */
    if (!arme || verrouille) return;
    verrouille = true;
    document.body.setAttribute('data-fm-pdp', 'fini');
    document.body.style.setProperty('--fm-pdp-pose', 1);
  }

  /* RELACHER LE VERROU — appele au changement de teinte, voir le bloc suivant.
     On retire l'attribut : product.css reactive les deux animations, et le
     panneau repart de l'etat correspondant au defilement courant. */
  function deverrouiller() {
    arme = false;                                  /* desarme jusqu'au retour en haut */
    if (!verrouille) return;
    verrouille = false;
    document.body.removeAttribute('data-fm-pdp');
    document.body.style.removeProperty('--fm-pdp-pose');
    if (!compositeur) calculer();
  }

  /* On EXPOSE la fonction plutot que de dupliquer la logique ailleurs : le
     bloc du selecteur de teintes, plus bas, n'a pas a connaitre le nom de
     l'attribut ni celui de la variable. Un seul endroit sait comment le
     verrou fonctionne. */
  window.__fmPdpDeverrouiller = deverrouiller;

  echelle();
  window.addEventListener('resize', auRedimensionnement, { passive: true });
  window.addEventListener('scroll', verrouiller, { passive: true });
  verrouiller();                                     /* page rouverte deja defilee */

  if (compositeur) return;                           /* le CSS prend le relais */

  calculer();
  window.addEventListener('scroll', auDefilement, { passive: true });
  if (portable.addEventListener) portable.addEventListener('change', auRedimensionnement);
  else if (portable.addListener) portable.addListener(auRedimensionnement);   /* Safari < 14 */
})();


/* ==========================================================================
   CHANGEMENT DE TEINTE : ON REMONTE EN HAUT, ET LE PANNEAU REJOUE
   --------------------------------------------------------------------------
   PORTABLE UNIQUEMENT. Sur ordi le panneau ne chevauche rien, remonter la
   page n'aurait aucun sens.

   L'ORDRE DES DEUX ACTIONS EST TOUT LE SUJET.
   On relache le verrou AVANT de faire remonter la page, pas apres.
     · Dans ce sens : les animations redeviennent actives alors qu'on est
       encore en bas. Le panneau est donc a l'etat pose, et il se souleve
       progressivement sur les 300 derniers pixels de la remontee. On VOIT le
       verre revenir sur la photo, avec le reflet de la nouvelle teinte.
     · Dans l'autre : on remonte tout en haut verrouille, donc rien ne bouge,
       puis on relache -> le panneau saute d'un coup a l'etat chevauche. Un
       a-coup, exactement ce qu'on a passe du temps a supprimer.

   `behavior: smooth` et pas un saut : la remontee fait partie de l'effet,
   c'est elle qui joue l'animation a l'envers. Un saut instantane la
   supprimerait.

   DELEGATION SUR document, et c'est necessaire : le theme RE-RENDU la section
   produit a chaque changement de variante. Un ecouteur pose sur les pastilles
   elles-memes disparaitrait au premier clic.

   ON ECOUTE `change` ET PAS `click`. Les pastilles sont des <input radio>
   habilles : on peut en selectionner une au clavier, et sur certains
   navigateurs un clic sur le label ne remonte pas comme un clic sur l'input.
   `change` couvre les deux et ne se declenche que si la valeur a reellement
   change — un re-clic sur la teinte deja choisie ne fait donc rien.
   ========================================================================== */
(function () {
  'use strict';

  var main = document.getElementById('MainContent');
  if (!main) return;
  if ((main.getAttribute('data-template') || '').indexOf('product') !== 0) return;

  var portable = window.matchMedia('(max-width: 750px)');

  document.addEventListener('change', function (e) {
    var cible = e.target;
    if (!cible || cible.type !== 'radio') return;
    if (!cible.closest || !cible.closest('.variant-picker')) return;
    if (!portable.matches) return;

    /* 1. le verrou tombe : les animations redeviennent actives */
    if (typeof window.__fmPdpDeverrouiller === 'function') {
      window.__fmPdpDeverrouiller();
    }

    /* 2. la page remonte, et c'est la remontee qui rejoue le geste */
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      window.scrollTo(0, 0);                         /* vieux navigateurs */
    }
  });
})();